import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';
import { useGlobalContext } from './context/GlobalContext';

const HeadManager = () => {
  const { store, customParams } = useGlobalContext();
  const { t, i18n } = useTranslation();
  const [cacheBuster, setCacheBuster] = useState(Date.now());
  const [faviconError, setFaviconError] = useState(false);

  useEffect(() => {
    setCacheBuster(Date.now());
    setFaviconError(false);
  }, [store?.favicon]);
  const defaultTitle = window.location.hostname.replace(/^www\.|\.com$/g, '');
  const defaultFavicon = `${window.location.origin}/favicon.ico`;
  
  const faviconUrl = store?.favicon && !faviconError 
    ? `${store.favicon}?v=${cacheBuster}`
    : defaultFavicon;
  return (
    <Helmet>
      <html lang={i18n.language || store?.default_language || 'fr'} />
      <title>
        {t('E-carte cadeau')} - {store?.libelle || defaultTitle}
      </title>

      <link
        rel="shortcut icon"
        href={faviconUrl}
      />
      {customParams?.css && (
        <link rel="stylesheet" href={customParams.css} type="text/css" />
      )}
      {customParams?.user_css && (
        <link rel="stylesheet" href={customParams.user_css} type="text/css" />
      )}

      {customParams?.typo && customParams?.typeTypo === 1 && (
        <link
          rel="stylesheet"
          href={`/assets/css/fonts/${customParams.typo}/stylesheet.css`}
          type="text/css"
        />
      )}

    </Helmet>
  );
};

export default HeadManager;
